import React from "react";
import styled from "@emotion/styled";

import mediaqueries from "@styles/media";

/**
 * Paste in your SVG logo and return it from this component.
 * Make sure you have a height set for your logo.
 * It is recommended to keep the height within 25-35px.
 * Logo comes with a property value called `fill`. `fill` is useful
 * when you want to change your logo depending on the theme you are on.
 */
export default function Logo({ fill }) {
  if (fill === "#fff") {
    fill = "white";
  } else {
    fill = "black";
  }

  return (
    <LogoContainer>
      <svg
        height="48"
        viewBox="0 0 588 217"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M280.369 88.528V166H259.057V156.784C256.081 160.144 252.529 162.736 248.401 164.56C244.273 166.288 239.809 167.152 235.009 167.152C224.833 167.152 216.769 164.224 210.817 158.368C204.865 152.512 201.889 143.824 201.889 132.304V88.528H224.353V128.992C224.353 141.472 229.585 147.712 240.049 147.712C245.425 147.712 249.745 145.984 253.009 142.528C256.273 138.976 257.905 133.744 257.905 126.832V88.528H280.369ZM381.101 88.528V153.04C381.101 167.248 377.405 177.808 370.013 184.72C362.621 191.632 351.821 195.088 337.613 195.088C330.125 195.088 323.021 194.176 316.301 192.352C309.581 190.528 304.013 187.888 299.597 184.432L308.525 168.304C311.789 170.992 315.917 173.104 320.909 174.64C325.901 176.272 330.893 177.088 335.885 177.088C343.661 177.088 349.373 175.312 353.021 171.76C356.765 168.304 358.637 163.024 358.637 155.92V152.608C352.781 159.04 344.621 162.256 334.157 162.256C327.053 162.256 320.525 160.72 314.573 157.648C308.717 154.48 304.061 150.064 300.605 144.4C297.149 138.736 295.421 132.208 295.421 124.816C295.421 117.424 297.149 110.896 300.605 105.232C304.061 99.568 308.717 95.2 314.573 92.128C320.525 88.96 327.053 87.376 334.157 87.376C345.389 87.376 353.933 91.072 359.789 98.464V88.528H381.101ZM338.621 143.824C344.573 143.824 349.421 142.096 353.165 138.64C357.005 135.088 358.925 130.48 358.925 124.816C358.925 119.152 357.005 114.592 353.165 111.136C349.421 107.584 344.573 105.808 338.621 105.808C332.669 105.808 327.773 107.584 323.933 111.136C320.093 114.592 318.173 119.152 318.173 124.816C318.173 130.48 320.093 135.088 323.933 138.64C327.773 142.096 332.669 143.824 338.621 143.824ZM477.897 127.552C477.897 127.84 477.753 129.856 477.465 133.6H418.857C419.913 138.4 422.409 142.192 426.345 144.976C430.281 147.76 435.177 149.152 441.033 149.152C445.065 149.152 448.617 148.576 451.689 147.424C454.857 146.176 457.785 144.256 460.473 141.664L472.425 154.624C465.129 162.976 454.473 167.152 440.457 167.152C431.721 167.152 423.993 165.472 417.273 162.112C410.553 158.656 405.369 153.904 401.721 147.856C398.073 141.808 396.249 134.944 396.249 127.264C396.249 119.68 398.025 112.864 401.577 106.816C405.225 100.672 410.169 95.92 416.409 92.56C422.745 89.104 429.801 87.376 437.577 87.376C445.161 87.376 452.025 89.008 458.169 92.272C464.313 95.536 469.113 100.24 472.569 106.384C476.121 112.432 477.897 119.488 477.897 127.552ZM437.721 104.368C432.633 104.368 428.361 105.808 424.905 108.688C421.449 111.568 419.337 115.504 418.569 120.496H456.729C455.961 115.6 453.849 111.712 450.393 108.832C446.937 105.856 442.713 104.368 437.721 104.368ZM539.94 87.376C549.54 87.376 557.268 90.256 563.124 96.016C569.076 101.776 572.052 110.32 572.052 121.648V166H549.588V125.104C549.588 118.96 548.244 114.4 545.556 111.424C542.868 108.352 538.98 106.816 533.892 106.816C528.228 106.816 523.716 108.592 520.356 112.144C516.996 115.6 515.316 120.784 515.316 127.696V166H492.852V88.528H514.308V97.6C517.284 94.336 520.98 91.84 525.396 90.112C529.812 88.288 534.66 87.376 539.94 87.376Z"
          fill={fill}
        />
        <rect x="29" y="30" width="163" height="168" fill="#C4C4C4" />
        <path
          d="M119.126 130.432V166H100.406V130.72L60.8056 65.2H80.8216L110.342 114.304L140.15 65.2H158.582L119.126 130.432Z"
          fill="black"
          fillOpacity="0.65"
        />
        <line
          x1="61"
          y1="44"
          x2="159.005"
          y2="44"
          stroke="black"
          strokeWidth="8"
        />
      </svg>
    </LogoContainer>
  );
}
const LogoContainer = styled.div`
  .Logo__Mobile {
    display: none;
  }
  ${mediaqueries.tablet`
    .Logo__Desktop {
      display: none;
    }
    
    .Logo__Mobile{
      display: block;
    }
  `}
`;
